module.exports = __webpack_public_path__ + "img/13.19a36d3a.webp";